export default [
    { path: '/feedback',name:'feedback', component: require('./components/recruitment_feedback/feedback/feedback.vue').default },
    { path: '/feedback_acknowledgement',name:'feedback_acknowledgement', component: require('./components/recruitment_feedback/feedback/feedback_acknowledgement.vue').default },
    { path: '/create_application',name:'feedback_acknowledgement', component: require('./components/recruitment_feedback/application/create_application.vue').default },
    { path: '/application_acknowledgement',name:'application_acknowledgement', component: require('./components/recruitment_feedback/application/acknowledgement.vue').default },


];
